import { observer } from "mobx-react";
import { FONT_COLOR } from "../../../../components/fonts/font-props";
import useDashboardTranslation from "../../../../dashboard-translation/hooks/dashboard-translation-hook";
import FontBody1 from "../../../../components/fonts/font-body1/font-body1";
import OnboardingPlanCardLayout from "./onboarding-plan-card-layout/onboarding-plan-card-layout";
import "./choose-plan-screen.scss";
import { IStepComponent } from "../../onboarding-page";
import ChoosePlanScreenStore from "../../stores/choose-plan-screen-store";
import onboardingPlansStores from "../../stores/onboarding-plans-stores";
import { useEffect, useState } from "react";
import { Button } from "../../../../components/inputs/button/button";
import IconBack from "../../../../components/icons/icon-back/icon-back";
import { BUTTON_VARIANTS } from "../../../../components/inputs/button-variants";
import IconNext from "../../../../components/icons/icon-next/icon-next";
import OnboardingDefaultNavigationControls from "../onboarding-default-navigation-controls/onboarding-default-navigation-controls";
import OnBoardingScreenTitle from "../onboarding-screen-title/onboarding-screen-title";
import OnboardingWizardStickyFooterPortal from "../onboarding-wizard-sticky-footer/onboarding-wizard-sticky-footer-portal";
import OnboardingPlanInfo from "./onboarding-plan-info/onboarding-plan-info";
import currentPortalStore from "../../../../stores/current-portal-store";

const ChoosePlanScreen:React.FC<IStepComponent> = observer((props) => {
    const store = props.store as ChoosePlanScreenStore;

    useEffect(() => {
        store.setDefaults();
    }, [store])

    const { getTranslation } = useDashboardTranslation();
    const scope = 'dashboard-onboarding';

    const [currentIndex, setCurrentIndex] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(onboardingPlansStores.onboardingCoveragePlan ? 3 : 4);
    const showNextButton = currentIndex + itemsPerPage < onboardingPlansStores.list.length;
    const showBackButton = currentIndex > 0 ;
    const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);

    const handleNext = () => {
        setCurrentIndex(currentIndex + itemsPerPage);
        setItemsPerPage(4);
    };

    const handlePrev = () => {
        if (currentIndex - itemsPerPage >= 0) {
            setCurrentIndex(currentIndex - itemsPerPage);
        }
        else {
            setItemsPerPage(3);
            setCurrentIndex(0);
        }
    };

    return (
        <>
            <div className="choose-plan-screen">

                <OnBoardingScreenTitle
                    titleText={getTranslation("CHOOSE_PLAN_TITLE",scope)}
                    descriptionText={
                        currentPortalStore.platform?.isShopify() ? 
                        `${getTranslation("CHOOSE_PLAN_SUBTITLE",scope)}\n${getTranslation("14_DAYS_FREE",scope)}` : 
                        undefined
                    }
                />

                <div className="choose-plan-contact-us">
                    <FontBody1 color={FONT_COLOR.PRIMARY2}>
                        {`${getTranslation('FOR_MORE_QUESTIONS_OR_CUSTOM_PLAN', scope)}, `}
                        <a href='https://returngo.ai/request-a-demo/' rel='noreferrer' target="_blank">
                            {getTranslation('CONTACT_US', scope)}
                        </a>
                    </FontBody1>
                </div>
                {showBackButton &&
                    <div className="choose-plan-content-back-btn">
                        <Button
                            onClick={handlePrev}
                            leftIcon={IconBack}
                            variant={BUTTON_VARIANTS.Transparent}
                        />
                    </div>
                }
                <div className="choose-plan-content">
                    <div className="plans-container">
                        {onboardingPlansStores.onboardingCoveragePlan && currentIndex === 0 &&
                            <OnboardingPlanCardLayout
                                radioButtonName="coverage-plan"
                                isChecked={onboardingPlansStores.onboardingCoveragePlan.id === store.planId}
                                onChange={() => store.setPlan(onboardingPlansStores.onboardingCoveragePlan!.id)}
                            >
                                <OnboardingPlanInfo 
                                    plan={onboardingPlansStores.onboardingCoveragePlan}
                                    isExpanded={isDescriptionExpanded}
                                    onToggle={() => setIsDescriptionExpanded(prev => !prev)}
                                />
                            </OnboardingPlanCardLayout>
                        }
                        {onboardingPlansStores.list.slice(currentIndex, currentIndex + itemsPerPage).map(plan => (
                            <OnboardingPlanCardLayout
                                radioButtonName={`plan-${plan.id}`}
                                isChecked={plan.id === store.planId}
                                onChange={() => store.setPlan(plan.id)}
                                key={plan.id}
                                tagBackground={plan.tag_color}
                                tagTitle={plan.tag}
                            >
                                <OnboardingPlanInfo 
                                    plan={plan}
                                    isExpanded={isDescriptionExpanded}
                                    onToggle={() => setIsDescriptionExpanded(prev => !prev)}
                                />

                            </OnboardingPlanCardLayout>
                        ))}
                    </div>
                </div>
                {showNextButton &&
                    <div className="choose-plan-content-next-btn">
                        <Button
                            onClick={handleNext}
                            leftIcon={IconNext}
                            variant={BUTTON_VARIANTS.Transparent}
                        />
                    </div>
                }
                <OnboardingWizardStickyFooterPortal>
                    <OnboardingDefaultNavigationControls
                        onBackClick={store.previousStep}
                        isNextDisabled={!store.isComplete()}
                        onNextClick={store.nextStep}
                        isLoading={store.isLoading}
                    />
                </OnboardingWizardStickyFooterPortal>
            </div>
        </>
    )
});

export default ChoosePlanScreen;